import { IconWrapper, PasswordInputWrapper } from "@components/inputs/input/Input.styles";
import React from "react";

import { IconSize } from "../../../enums";
import Input, { IInputProps } from "./Input";
import { WithPasswordInput, withPasswordInput } from "./withPasswordInput";

interface IProps extends IInputProps {

}

class PasswordInput extends React.PureComponent<IProps & WithPasswordInput> {
    render = () => {
        const Icon = this.props.password.icon;
        const isDisabled = this.props.isDisabled;
        const isReadOnly = this.props.isReadOnly;
        const isDisabledOrReadOnly = isDisabled || isReadOnly;
        return (
            <PasswordInputWrapper
                $isReadOnly={isReadOnly}
                $isDisabled={isDisabled}>
                <Input {...this.props}
                       passRef={this.props.password.inputRef}
                       onIconClick={this.props.password.onIconClick}
                       type={this.props.password.type}
                       isDisabled={isDisabledOrReadOnly}
                       isReadOnly={false}
                       icon={isDisabledOrReadOnly ? null : <Icon width={IconSize.M}/>}
                       iconTitle={this.props.password.iconTitle}/>
                {isDisabledOrReadOnly &&
                    <IconWrapper
                        onClick={this.props.password.onIconClick}
                    >
                        <>
                            <Icon width={IconSize.M} height={IconSize.M}/>
                        </>
                    </IconWrapper>
                }
            </PasswordInputWrapper>
        );
    };
}

export default withPasswordInput(PasswordInput);